import { IconProps } from "ztypes/icon-props";

const IconThreeDot: React.FunctionComponent<IconProps> = (props) => {
  return (
    <svg
      className={props.className}
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5622 8.4557C12.5622 9.03867 13.0348 9.51126 13.6178 9.51126C14.2008 9.51126 14.6733 9.03867 14.6733 8.4557C14.6733 7.87273 14.2008 7.40015 13.6178 7.40015C13.0348 7.40015 12.5622 7.87273 12.5622 8.4557ZM7.98815 8.4557C7.98815 9.03867 8.46074 9.51126 9.04371 9.51126C9.62668 9.51126 10.0993 9.03867 10.0993 8.4557C10.0993 7.87273 9.62668 7.40015 9.04371 7.40015C8.46074 7.40015 7.98815 7.87273 7.98815 8.4557ZM4.46964 9.51126C3.88667 9.51126 3.41408 9.03867 3.41408 8.4557C3.41408 7.87273 3.88667 7.40015 4.46964 7.40015C5.0526 7.40015 5.52519 7.87273 5.52519 8.4557C5.52519 9.03867 5.0526 9.51126 4.46964 9.51126Z"
        fill="#6F7071"
      />
    </svg>
  );
};

export default IconThreeDot;
